import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
const FormFieldContext = createContext({});
const FormFieldProvider = ({
  children,
  shouldValidate,
  setCharacterCount,
  valid
}) => {
  return /* @__PURE__ */ jsx(
    FormFieldContext.Provider,
    {
      value: {
        shouldValidate,
        setCharacterCount,
        valid
      },
      children
    }
  );
};
var FormFieldContext_default = FormFieldContext;
export {
  FormFieldContext,
  FormFieldProvider,
  FormFieldContext_default as default
};
